
    import { computed, defineComponent } from 'vue'

    import { useSharedSettingsStore } from '@/common/stores/shared-settings'

    export default defineComponent({
        setup () {
            const settingsStore = useSharedSettingsStore()
            const facebookUrl = computed(() => settingsStore.setting('social-facebook'))
            const instagramUrl = computed(() => settingsStore.setting('social-instagram'))
            const linkedInUrl = computed(() => settingsStore.setting('social-linkedin'))
            const tikTokUrl = computed(() => settingsStore.setting('social-tiktok'))
            const youTubeUrl = computed(() => settingsStore.setting('social-youtube'))

            return {
                facebookUrl,
                instagramUrl,
                linkedInUrl,
                tikTokUrl,
                youTubeUrl
            }
        }
    })
